import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["mainDashboard", "journey", "ticket", "3333", "4444", "5555", "6666", "7777", "8888", "9999"]

  connect() {
    this.controllerName = `financials--books--clients--renewals--tickets`
    this.blockedAdd = false
  }

  doTicketsDashboard() {
    var html = `<div class="col-12 pl-1" data-users--works--activities--shared--tickets-target="main" data-controller="users--works--activities--shared--tickets"></div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier(`financials--books--clients--renewals--show`).ticketsRowTarget.innerHTML = html)
    }).then(() => {

      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).permission = `financial_client_renewals`
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).blockedAdd = controller.blockedAdd
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).sharing = false
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).kind = true
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).priority = true
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).term = true
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).itemsOnRow = 4
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).ticket_board = {
        board_id: controller.current_renewal.contract_id,
        board_type: `financial_contracts`,
        board_subtype: `financial_contracts`,
        board_path: `/a/contratos-financeiros`,
        board_name: `Renovação | ${controller.current_renewal.client_name} | ${controller.current_renewal.contract_name}`,
        date_id: controller.application.current_date.id,
        date_type: `financials_dates`,
        obj_id: controller.current_renewal.id,
        obj_type: `financial_client_renewals`,
      }
      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).comment_board = {
        board_id: controller.current_renewal.contract_id,
        board_type: `financial_contracts`,
        date_id: controller.application.current_date.id,
        date_type: `financials_dates`
      }

      controller.getControllerByIdentifier(`users--works--activities--shared--tickets`).doIndexListHtml()
    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
